module.exports = __webpack_public_path__ + "img/mouse.41ff66b9.svg";